import HeroSection from "../components/HeroSection";
import Marquee from "../components/Marquee";
import ServicesBento from "../components/ServicesBento";
import ProcessSection from "../components/ProcessSection";
import PhotoTextLine from "../components/PhotoTextLine";
import GallerySection from "../components/GallerySection";
import ReviewsSection from "../components/ReviewsSection";
import ServiceArea from "../components/ServiceArea";
import FAQSection from "../components/FAQSection";
import CTASection from "../components/CTASection";
import { Seo, HOME_JSON_LD } from "../components/Seo";

const Home = () => (
    <main>
        <Seo
            description="Stump grinding in Poplar Bluff, MO and 30 miles around — Dexter, Doniphan, Puxico, Wappapello and more. Upfront pricing by stump size, full cleanup, same-week guarantee. Call or text (573) 300-8625."
            jsonLd={HOME_JSON_LD}
        />
        <HeroSection />
        <Marquee />
        <ServicesBento />
        <ProcessSection />
        <GallerySection />
        <ReviewsSection />
        <PhotoTextLine />
        <ServiceArea />
        <FAQSection />
        <CTASection />
    </main>
);

export default Home;
